export function parseJson<T = any>(text: string): T | null {
    try {
        return JSON.parse(text);
    } catch (error) {
        return null;
    }
}

function random6(): string {
    return Math.random().toFixed(6)
        .slice(-6);
}

export function getRequestId(seq: number): string {
    return `${Date.now()}_${random6()}_${seq}`;
}

